import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { USER } from "constants/AuthConstant";
import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";

export const unitAdd = createAsyncThunk("units/unitAdd", async (data, { rejectWithValue }) => {
	try {
		const user_channel = PermissionManager.getItem(USER)?.user?.user_channel[0]?.channel_uuid;
		const response = await axiosHttp.post(`channel/${user_channel}/unit`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const initialState = {
	isLoading: false,
	isError: false,
	error: null,
	data: null,
};
const CreateUnitSlice = createSlice({
	name: "CreateUnitSlice",
	initialState,
	reducers: {
		resetUnitAddState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(unitAdd.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(unitAdd.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(unitAdd.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetUnitAddState } = CreateUnitSlice.actions;
export default CreateUnitSlice.reducer;
